const setShowAISlideGeneratorModal = (state, payload) => {
  state.slideGenerator.isAISlideGeneratorModalVisible = payload.show
  if (!payload.touchPoint) return
  state.slideGenerator.gaTouchPointWhenOpenAIModal = payload.touchPoint
}

export default {
  setShowAISlideGeneratorModal,
}
